import React from "react";

// Design-kit components/navigation/SportRail.jsx, ported 1:1 (markup + .bet-rail*
// CSS in index.css). The kit's `it.icon` is a name string resolved by its own
// Icon component; we don't have a per-sport icon set yet, so items render
// without one — the CSS still degrades correctly (`.bet-rail__item svg` rules
// simply have nothing to select).
export default function SportRail({ groups = [], value, onChange, className = "", style, ...rest }) {
  return (
    <nav className={`bet-rail ${className}`} style={style} {...rest}>
      {groups.map((g, gi) => (
        <div className="bet-rail__group" key={g.title || gi}>
          {g.title ? <div className="bet-rail__title">{g.title}</div> : null}
          {g.items.map((it) => (
            <button
              key={it.id}
              type="button"
              className="bet-rail__item"
              aria-current={value === it.id}
              onClick={() => onChange && onChange(it.id)}
            >
              {it.icon}
              <span className="bet-rail__label">{it.label}</span>
              {it.count != null ? <span className="bet-rail__count">{it.count}</span> : null}
            </button>
          ))}
        </div>
      ))}
    </nav>
  );
}
